"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { mixpanelV2Client } from "services/mixpanelv2";
import { setReferralChannel } from "utils/local-storage";

/**
 * This and "TabsCountLogicForReferralChannel" components will handle the logic to
 * decide the the channel (referralChannel) of the booking. ex. google, facebook, whimstay, etc...
 * and if the  channel was direct or indirect (directChannel: true/false).
 *
 * default channel will be "whimstay" and "direct" (referralChannel: whimstay, directChannel: true).
 *
 * It uses "isgoogle" and "whimreferral" query params to decide the channel.
 * currently "isgoogle" or "whimreferral=google" is the only channel we will get but
 * to handle future case we will expact other channels in "whimreferral" query param in URL.
 * to make it backward compatible we will handle "isgoogle".
 *
 * ** Cases:
 *
 * => if customer books the original property which customer landed on then
 *    it will be considered as "direct" booking (directChannel: true).
 *
 * => if customer come from any channel (not whimstay) ex. GVR (google vacation rental) on one property detail page
 *    but doesn't book that particular property and books the different property then it will be
 *    "indirect" booking (directChannel: false). As long as it was a Active browser session from when customer
 *    came from GVR (or any other channel).
 *
 * Note: Here, customers "Active browser session" will end when customer closes all the tabs of our site (whimstay.com)
 *       after that if customer books any property then it will be whimstay direct (referralChannel: whimstay, directChannel: true) booking.
 *
 * => if user doesn't come from any channel and books a property then it will be direct whimstay bookig.
 *    (referralChannel: whimstay, directChannel: true)
 *
 */

const SaveReferralChannel = () => {
  const searchParams = useSearchParams();
  useEffect(() => {
    const isGoogle = searchParams?.get("isgoogle") ?? "";
    const whimReferral = searchParams?.get("whimreferral") ?? "";
    if (isGoogle === "true") {
      document.cookie = `isGoogle=${isGoogle}; path=/`; // Save in session cookie (no expiration) to track GVR

      setReferralChannel("google");
      // Set GVR user property in Mixpanel user profile
      // This will be used to identify if the user is coming from GVR or not
      void mixpanelV2Client?.SET_IS_GVR_USER();
    }
    if (whimReferral) {
      setReferralChannel(whimReferral);
    }
  }, [searchParams]);
  return null;
};
export default SaveReferralChannel;